module.exports = __webpack_public_path__ + "img/library.6e98e54f.svg";